var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog_wrapper",
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        width: _vm.width,
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closed,
      },
    },
    [
      _c(
        _vm.name,
        _vm._b(
          { ref: "content", tag: "component", on: { hide: _vm.hide } },
          "component",
          _vm.contentPropsData,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }